import { msgApi } from 'yxt-biz-pc/packages/api';

// 根据会话ID，获取会话详情
export const getChatInfo = (chatId) => {
  return msgApi.get(`chat/${chatId}`);
};
